/**
 *  时间类计算模块
 */
$t = window.vm.$t.bind(window.vm)
// 计算某个时间戳距离现在的时间
export const timeInterval = function (timestamp, endTime = new Date()) {
  const startTime = new Date(timestamp) // 开始时间
  // const endTime = new Date(); // 结束时间
  const usedTime = endTime - startTime // 相差的毫秒数
  const days = Math.floor(usedTime / (24 * 3600 * 1000)) // 计算出天数
  const leavel = usedTime % (24 * 3600 * 1000) // 计算天数后剩余的时间
  const hours = Math.floor(leavel / (3600 * 1000)) // 计算剩余的小时数
  const leavel2 = leavel % (3600 * 1000) // 计算剩余小时后剩余的毫秒数
  const minutes = Math.floor(leavel2 / (60 * 1000)) // 计算剩余的分钟数
  return (
    days +
    $t('public.day') +
    ' ' +
    hours +
    $t('public.hour') +
    ' ' +
    minutes +
    $t('public.minute')
  )
}

//  秒数转化为时分秒
export const formatSeconds = function (value) {
  //  秒
  let second = parseFloat(value)
  //  分
  let minute = 0
  //  小时
  let hour = 0
  //  天
  let day = 0
  //  如果秒数大于60，将秒数转换成整数
  if (second > 60) {
    //  获取分钟，除以60取整数，得到整数分钟
    minute = parseInt(second / 60)
    //  获取秒数，秒数取佘，得到整数秒数
    second = parseInt(second % 60)
    //  如果分钟大于60，将分钟转换成小时
    if (minute > 60) {
      //  获取小时，获取分钟除以60，得到整数小时
      hour = parseInt(minute / 60)
      //  获取小时后取佘的分，获取分钟除以60取佘的分
      minute = parseInt(minute % 60)
      //  如果小时大于24，将小时转换成天
      if (hour > 23) {
        //  获取天数，获取小时除以24，得到整天数
        day = parseInt(hour / 24)
        //  获取天数后取余的小时，获取小时除以24取余的小时
        hour = parseInt(hour % 24)
      }
    }
  }

  let result = ''
  if (second > 0) {
    result = '' + parseInt(second) + $t('integration.second')
  }

  if (minute > 0) {
    result = '' + parseInt(minute) + $t('integration.branch') + result
  }
  if (hour > 0) {
    result = '' + parseInt(hour) + $t('integration.hour') + result
  }
  if (day > 0) {
    result = '' + parseInt(day) + $t('integration.day') + result
  }

  if (result === '') {
    result = '' + parseInt(second) + $t('integration.second')
  }
  return result
}

// 判断时间范围是否超过30天  30天使用轮询的方式
export const isTimeExceedThreshold = function (
  startTimeStamp,
  endTimeStamp,
  days = 10
) {
  // 默认30天
  var thisMothDays = 1000 * 3600 * 24 * days
  if (endTimeStamp - startTimeStamp > thisMothDays) {
    return true
  } else {
    return false
  }
}
